module.exports = __webpack_public_path__ + "media/announce.beac0d9b.mp3";